import Upcoming from '@/components/Sessions/Upcoming';
import { MemberSessionsPage } from '@/features/adminMemberSessions/AdminMemberSessions';

const UpcomingSessions = () => (
  <MemberSessionsPage>
    <Upcoming />
  </MemberSessionsPage>
);

export default UpcomingSessions;
